// in src/authClient.js
import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_ERROR,
  AUTH_CHECK,
  AUTH_GET_PERMISSIONS
} from 'admin-on-rest';
import get from 'lodash.get';
import fetcher from './helpers/fetcher';
import { SIGNIN_URL, URL_REFRESH_TOKEN } from './constants';

const KEY_USERNAME = 'username';
const KEY_USER_ID = 'userId';
const KEY_TOKEN = 'token';
const KEY_EMAIL = 'email';
const KEY_ROLE = 'role';

export const getToken = () => localStorage.getItem(KEY_TOKEN);
export const getUserId = () => localStorage.getItem(KEY_USER_ID);
export const getUsername = () => localStorage.getItem(KEY_USERNAME);

export const logout = () => {
  localStorage.removeItem(KEY_TOKEN);
  // localStorage.removeItem('role');
  localStorage.removeItem(KEY_EMAIL);
  localStorage.removeItem(KEY_USERNAME);
  localStorage.removeItem(KEY_USER_ID);
  fetcher.defaults.headers.common['Authorization'] = '';
};

export const goToLogin = () => {
  setTimeout(() => window.location.replace('#/login'), 1);
  return false;
};

export const refreshToken = () =>
  fetcher
    .post(URL_REFRESH_TOKEN, { token: (getToken() || '').replace('JWT ', '') })
    .then(response => {
      const newToken = get(response, 'data.data.token');
      if (newToken) {
        let token = `JWT ${newToken}`;
        localStorage.setItem(KEY_TOKEN, token);
        fetcher.defaults.headers.common['Authorization'] = getToken();
        return true;
      }
      return false;
    });

//If already authenticated
fetcher.defaults.headers.common['Authorization'] = getToken();

export default (type, params) => {
  // called when the user attempts to log in
  if (type === AUTH_LOGIN) {
    const { username, password } = params;

    if (fetch) {
      return fetch(SIGNIN_URL, {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify({
          username: username,
          password: password
        })
      })
        .then(function(response) {
          return response.json();
        })
        .then(function(response) {
          let token = `JWT ${response.data.token}`;
          localStorage.setItem(KEY_EMAIL, response.data.user.email);
          localStorage.setItem(KEY_USERNAME, response.data.user.username);
          localStorage.setItem(KEY_TOKEN, token);
          localStorage.setItem(KEY_ROLE, response.data.user.role || 'agent');
          localStorage.setItem(KEY_USER_ID, response.data.user.id);
          fetcher.defaults.headers.common['Authorization'] = getToken();
          // accept all username/password combinations
          return Promise.resolve(response.data.user);
        })
        .catch(function(e) {
          console.log(e);
          return Promise.reject();
        });
    }
  }
  // called when the user clicks on the logout button
  if (type === AUTH_LOGOUT) {
    logout();
    return Promise.resolve();
  }
  // called when the API returns an error
  if (type === AUTH_ERROR) {
    const { status } = params;
    if (status === 401 || status === 403) {
      logout();
      return Promise.reject();
    }
    return Promise.resolve();
  }
  // called when the user navigates to a new location
  if (type === AUTH_CHECK) {
    return getToken() ? Promise.resolve() : Promise.reject();
  }
  if (type === AUTH_GET_PERMISSIONS) {
    return localStorage.getItem(KEY_ROLE)
      ? Promise.resolve(localStorage.getItem(KEY_ROLE))
      : goToLogin() || Promise.reject();
  }
  return Promise.reject('Unknown method');
};



// WEBPACK FOOTER //
// ./src/authClient.js